import MONSTRO_1 from "url:../sprites/catarro.png";
import SOM_7 from "url:../sfx/peido.m4a";

export default {
  attack: 1,
  life: 5,
  speed: 9,
  agility: 6,
  image: MONSTRO_1,
  sound: SOM_7,
};
